import angular from 'angular';
import expensesComponent from './expenses.component';
import expenseWizard from './expense-wizard/expense-wizard';
import travelExpense from './travel-expense/travel-expense';
import travelExpenseDetails from './travel-expense-details/travel-expense-details';
import travelExpenseActuals from './travel-expense-actuals/travel-expense-actuals';
import generalBusiness from './general-business/general-business';
import generalBusinessDetails from './general-business-details/general-business-details';
import generalBusinessActuals from './general-business-actuals/general-business-actuals';
import otherDirectCosts from './other-direct-costs/other-direct-costs';
import otherDirectCostsDetails from './other-direct-costs-details/other-direct-costs-details';
import otherDirectCostsActuals from './other-direct-costs-actuals/other-direct-costs-actuals';

let reviewModule = angular.module('expenses', [
  'ui.router', expenseWizard.name, travelExpense.name, travelExpenseDetails.name, travelExpenseActuals.name,
  generalBusiness.name, generalBusinessDetails.name, generalBusinessActuals.name,
  otherDirectCosts.name, otherDirectCostsDetails.name, otherDirectCostsActuals.name
])
.component('expenses', expensesComponent);

export default reviewModule;



// WEBPACK FOOTER //
// ./client/pages/expenses/expenses.js